import React from 'react';
import { OtherOption } from './StatusSection/OtherOption';
import { AcceptanceStatusSection } from './StatusSection/AcceptanceStatusSection';
import { ApprovalStatusSection } from './StatusSection/ApprovalStatusSection';
import { EffectiveDateSection } from './StatusSection/EffectiveDateSection';
import { ApprovalStatus, EndDate, StartDate } from 'app/models/Placement/PlacementMods';
import { useSelector } from 'react-redux';
import { selectIsEditExistingMod, selectIsEditMod } from 'store/redux-store/placement-mods/selectors';
import { selectUser } from 'oidc/user.selectors';
import { isClientContractAdminUser, isReadOnly, userRoles } from 'oidc/userRoles';
import { Authorized } from 'oidc/userHelper';

export const DialogButtonComponent = dialogProps => {
  const { currentModDetails, modsDialogDetails } = dialogProps;
  const isModEdit = useSelector(selectIsEditMod);
  const isEditExistingMod = useSelector(selectIsEditExistingMod);
  const appUser = useSelector(selectUser);

  const showOptions = () => {
    const modName = modsDialogDetails.selectedMod?.replace(/\s/g, '');
    if (isModEdit && !isEditExistingMod) {
      return false;
    } else if (isReadOnly(appUser?.userInfo?.roles || [])) {
      return false;
    } else if (
      currentModDetails.isNegativeStatus ||
      (currentModDetails.isBookingApprovedOrGreater === false &&
        currentModDetails.standard &&
        (currentModDetails?.approvalStatusId === 3 || currentModDetails?.approvalStatusId === 2)) ||
      (currentModDetails.standard && currentModDetails.isBookingApprovedOrGreater === false && modName === 'Bonus') ||
      currentModDetails.voidStatus === true ||
      (modName === EndDate &&
        currentModDetails.approvalStatusId === ApprovalStatus.RecruiterApproved &&
        currentModDetails.isBookingApprovedOrGreater) ||
      ((modName === EndDate || modName === StartDate) &&
        currentModDetails.isBookingApprovedOrGreater &&
        currentModDetails?.approvalStatusId !== 1 &&
        currentModDetails?.approvalStatusId !== 4)
    ) {
      return false;
    } else {
      if (currentModDetails.isBookingApprovedOrGreater && currentModDetails.enableVoidOption) {
        if (
          (modName === 'BillRate' || modName === 'BillingShiftDifferential') &&
          isClientContractAdminUser(appUser?.userInfo?.roles || [])
        ) {
          return true;
        } else if (
          !Authorized(
            [userRoles.candidate_Contracts_Leadership, userRoles.candidate_Contracts_TeamMember],
            appUser.userInfo,
          ) ||
          isReadOnly(appUser?.userInfo?.roles || [])
        ) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    }
  };

  return (
    <React.Fragment>
      <EffectiveDateSection {...dialogProps} />
      <AcceptanceStatusSection {...dialogProps} />
      <ApprovalStatusSection {...dialogProps} />
      {showOptions() && <OtherOption {...dialogProps} />}
    </React.Fragment>
  );
};
